import _ from 'lodash';

export function simpleStateMerge(state, { payload }) {
  return _.merge({}, state, payload);
}
